import { adaptedToAgent, agentToAdapted, agentsToAdapted } from "../../adapter/agentAdapter";
import { HttpMethod, initFetch } from "../../utils/fetcher";

export const LOAD_SUCCESS_AGENTS = "LOAD_SUCCESS_AGENTS";
export const LOAD_FAIL_AGENTS = "LOAD_FAIL_AGENTS";
export const SAVE_SUCCESS_AGENTS = "SAVE_SUCCESS_AGENTS";
export const SAVE_FAIL_AGENTS = "SAVE_FAIL_AGENTS";
export const UPDATE_SUCCESS_AGENTS = "UPDATE_SUCCESS_AGENTS";
export const UPDATE_FAIL_AGENTS = "UPDATE_FAIL_AGENTS";
export const DELETE_SUCCESS_AGENTS = "DELETE_SUCCESS_AGENTS";
export const DELETE_FAIL_AGENTS = "DELETE_FAIL_AGENTS";

export function loadAgents() {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesAgents`, HttpMethod.GET);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.personne_agent);
          dispatch({
            type: LOAD_SUCCESS_AGENTS,
            payload: agentsToAdapted(res.personne_agent),
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: LOAD_FAIL_AGENTS,
            error: err,
          });
        });
    });
  };
}

export function saveAgent(jsonData) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesAgents`, HttpMethod.POST);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToAgent(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.personne_agent);
          dispatch({
            type: SAVE_SUCCESS_AGENTS,
            payload: agentToAdapted(res.personne_agent),
          });
        })
        .catch((err) =>
          dispatch({
            type: SAVE_FAIL_AGENTS,
            error: err,
          })
        );
    });
  };
}

export function updateAgent(jsonData, id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesAgents/${id}`, HttpMethod.PUT);
      // make async call to database
      fetch(url, { ...params, body: JSON.stringify(adaptedToAgent(jsonData)) })
        .then((res) => res.json())
        .then((res) => {
          resolve(res.personne_agent);
          dispatch({
            type: UPDATE_SUCCESS_AGENTS,
            payload: agentToAdapted(res.personne_agent),
          });
        })
        .catch((err) =>
          dispatch({
            type: UPDATE_FAIL_AGENTS,
            error: err,
          })
        );
    });
  };
}

export function deleteAgent(id) {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const { url, params } = initFetch(`personnesAgents/${id}`, HttpMethod.DELETE);
      // make async call to database
      fetch(url, params)
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            throw new Error("500");
          }
        })
        .then((res) => {
          resolve(res.personne_agent);
          dispatch({
            type: DELETE_SUCCESS_AGENTS,
            payload: agentToAdapted(res.personne_agent),
            id: id,
          });
        })
        .catch((err) => {
          reject(err);
          dispatch({
            type: DELETE_FAIL_AGENTS,
            error: err,
          });
        });
    });
  };
}
